import HttpService from './HttpService';

const BASE_URL = 'mail/';

export default class MailService {
  constructor() {
    this.httpService = new HttpService();
  }

  async SendMail(mail) {
    return this.httpService.Request(`${BASE_URL}send`, {
      method: 'POST',
      data: mail,
    });
  }
}
